import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';

export function useSectorPermissions() {
  const getters = useStoreGetters();
  const accountRole = computed(() => getters.getCurrentRole.value);
  const currentSectorRole = computed(() => getters.getCurrentSectorRole.value);

  const isAccountAdmin = computed(() =>
    ['administrator', 'super_admin'].includes(accountRole.value)
  );

  const hasSectorMembership = computed(
    () => !isAccountAdmin.value && currentSectorRole.value !== null
  );

  const isSectorAdmin = computed(
    () => currentSectorRole.value === 'sector_admin'
  );

  const isSectorManager = computed(() =>
    isAccountAdmin.value ||
    ['sector_admin', 'supervisor'].includes(currentSectorRole.value)
  );

  const showSectorConversationNav = computed(
    () => isAccountAdmin.value || hasSectorMembership.value
  );

  const canUploadKnowledgeBase = computed(
    () => isAccountAdmin.value || hasSectorMembership.value
  );

  return {
    isAccountAdmin,
    isSectorAdmin,
    isSectorManager,
    hasSectorMembership,
    canUploadKnowledgeBase,
    canSeeConversationsTab: computed(
      () => isAccountAdmin.value || hasSectorMembership.value
    ),
    canSeeReports: computed(() => isAccountAdmin.value || isSectorAdmin.value),
    canSeeAutomations: isAccountAdmin,
    canSeeCampaigns: isAccountAdmin,
    canSeeWebhooks: isAccountAdmin,
    showSectorConversationNav,
    showSectorNav: computed(
      () => !isAccountAdmin.value && hasSectorMembership.value
    ),
  };
}
